import React, {useEffect,useRef,useState} from 'react';
import {Dialog} from '@headlessui/react';
import {toast} from 'react-hot-toast';
import {Button} from '@/components/ui/button';
import CompanyCurrencyFields from './CompanyCurrencyFields';
import {companyCurrencyForm,companyCurrencyPayload} from '@/lib/companySettingsRequests';
import {companySettingsApi} from '@/lib/companySettingsApi';

export default function CompanyCurrencyEditor({company,onSaved}) {
  const [open,setOpen] = useState(false), [loading,setLoading] = useState(false);
  const [loaded,setLoaded] = useState(false);
  const [saving,setSaving] = useState(false), [uncertain,setUncertain] = useState(false);
  const [error,setError] = useState(''), [form,setForm] = useState(companyCurrencyForm());
  const generation = useRef(0), alive = useRef(true);
  useEffect(()=>{alive.current=true;return()=>{alive.current=false;generation.current++;};},[]);
  async function load() {
    const ticket = ++generation.current;
    setLoading(true);setLoaded(false);setError('');setForm(companyCurrencyForm());
    try {
      const stored = await companySettingsApi.get(company.id);
      if (!alive.current || generation.current !== ticket) return;
      setForm(companyCurrencyForm(stored));setUncertain(false);setLoaded(true);
    } catch {if(alive.current && generation.current === ticket) setError('Company settings could not be loaded. Refresh before saving.');}
    finally {if(alive.current && generation.current === ticket) setLoading(false);}
  }
  function close() {if(saving)return;generation.current++;setOpen(false);}
  async function save(e) {
    e.preventDefault();if(saving || loading || !loaded || uncertain || error)return;
    let payload;
    try {payload=companyCurrencyPayload(form);}catch(e){setError(e.message);return;}
    setSaving(true);setError('');
    try {
      const stored = await companySettingsApi.update(company.id,payload);
      if(!alive.current)return;
      onSaved(stored);toast.success('Company reporting settings saved');setOpen(false);
    } catch(e) {if(alive.current){setError(e.message);setUncertain(Boolean(e.uncertain));}}
    finally {if(alive.current)setSaving(false);}
  }
  return <>
    <Button size="sm" variant="outline" onClick={e=>{e.preventDefault();e.stopPropagation();setOpen(true);load();}}>Reporting settings</Button>
    <Dialog open={open} onClose={close}>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-3" onClick={e=>e.stopPropagation()}>
        <Dialog.Panel className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-xl bg-white p-6 text-gray-900 shadow">
          <Dialog.Title className="text-lg font-bold">Reporting settings — {company.company_name}</Dialog.Title>
          <p className="mt-1 text-xs text-gray-500">Company #{company.id}. Existing POs retain their stored currency and exchange-rate snapshots.</p>
          {loading && <p className="mt-3 text-sm">Loading company settings…</p>}
          {error && <p role="alert" className="mt-3 text-sm text-red-600">{error}</p>}
          <form onSubmit={save} className="mt-4 space-y-4">
            <CompanyCurrencyFields value={form} onChange={value=>{setForm(value);if(!uncertain)setError('');}} disabled={!loaded || loading || saving || uncertain}/>
            <div className="flex flex-wrap justify-end gap-2">
              <Button type="button" variant="outline" onClick={close} disabled={saving}>Close</Button>
              <Button type="button" variant="secondary" onClick={load} disabled={loading || saving}>Refresh settings</Button>
              <Button type="submit" disabled={!loaded || loading || saving || uncertain || Boolean(error)}>{saving?'Saving…':'Save reporting settings'}</Button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  </>;
}
